export function buildChipPath(chipReference: number | string): string {
  return `/chip/${encodeURIComponent(String(chipReference))}`;
}

export function buildCanonicalChipPath(chipId: number, search = '', hash = ''): string {
  return `${buildChipPath(chipId)}${search}${hash}`;
}

export function buildQaLabelChipUrl(chipName: string, locationLike: Pick<Location, 'origin' | 'search' | 'hash'>): string {
  return `${locationLike.origin}${buildChipPath(chipName)}${locationLike.search}${locationLike.hash}`;
}
